import React, { useState, useEffect } from 'react';
import { Select, MenuItem, FormControl, FormHelperText } from '@material-ui/core';
import moment from "moment";

const DatePickerDropdown = ({
    dateSelected = "",
    onChange,
    classes
}) => {
    const [selectedYear, setSelectedYear] = useState(getDateValue("year"));
    const [selectedMonth, setSelectedMonth] = useState(getDateValue("month"));
    const [selectedDate, setSelectedDate] = useState(getDateValue("day"));

    function getDateValue(type) {
        if (moment(moment(dateSelected).toDate()).isValid()) {
            switch (type) {
                case "year":
                    return moment(dateSelected).year();

                case "month":
                    return moment(dateSelected).month()+1;

                default:
                    return moment(dateSelected).date();
            }
        }
        return '';
    }

    const handleYearChange = (e) => {
        setSelectedYear(e.target.value);
    };

    const handleMonthChange = (e) => {
        setSelectedMonth(e.target.value);
    };

    const handleDateChange = (e) => {
        setSelectedDate(e.target.value);
    };

    const getDaysInMonth = (year, month) => {
        return new Date(year, month, 0).getDate();
    };



    useEffect(() => {
        if (onChange) {
            if (selectedYear && selectedMonth && selectedDate && isValidDate(selectedYear, selectedMonth, selectedDate)) {
                let selectedDateObj = new Date(selectedYear, selectedMonth - 1, selectedDate);
                onChange(moment(selectedDateObj).format('yyyy-MM-DD'));
            }
        }
    }, [selectedYear, selectedMonth, selectedDate]);




    const isValidDate = (year, month, date) => {
        let selectedDateObj = new Date(year, month - 1, date);
        let selectedYear = selectedDateObj.getFullYear();
        let selectedMonth = selectedDateObj.getMonth() + 1;
        let selectedDay = selectedDateObj.getDate();

        if (
            selectedYear === parseInt(year, 10) &&
            selectedMonth === parseInt(month, 10) &&
            selectedDay === parseInt(date, 10)
        ) {
            if (selectedMonth === 2 && date === 29) {
                // Check for leap year
                return isLeapYear(selectedYear);
            }
            return true;
        }

        return false;
    };

    const isLeapYear = (year) => {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    };

    const generateYearsOptions = () => {
        let currentYear = new Date().getFullYear();
        let years = [];

        //limit to 4 years forward and  2 years backward from current year - ML20-5635
        for (let i = currentYear - 2; i <= currentYear + 4; i++) {
            years.push(i);
        }

        return years.map((year) => (
            <MenuItem key={year} value={year} autoFocus={!selectedYear && year === currentYear}>
                {year}
            </MenuItem>
        ));
    };

    const generateMonthsOptions = () => {
        let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        let currentMonth = new Date().getMonth();
        return months.map((month, i) => (
            <MenuItem key={month} value={i + 1} autoFocus={!selectedMonth && currentMonth === (i + 1)}>
                {month}
            </MenuItem>
        ));
    };

    const generateDatesOptions = () => {
        if (selectedYear && selectedMonth) {
            let numDaysInMonth = getDaysInMonth(selectedYear, selectedMonth);
            let dates = Array.from({ length: numDaysInMonth }, (_, index) => index + 1);
            let currentDate = new Date().getDate();

            return dates.map((date) => (
                <MenuItem key={date} value={date} autoFocus={!selectedDate && currentDate === (date)}>
                    {date}
                </MenuItem>
            ));
        }

        return null;
    };

    const validateDate = () => {
        if (selectedYear && selectedMonth && selectedDate) {
            let isValid = isValidDate(selectedYear, selectedMonth, selectedDate);
            return isValid ? 'valid' : 'invalid';
        }

        return '';
    };

    return (
        <div >
            <div className={classes.dateDropdownPicker}>
            <FormControl>
                <FormHelperText>Year</FormHelperText>
                <Select value={selectedYear} onChange={handleYearChange} displayEmpty>
                    <MenuItem value="" disabled>
                        Year
                    </MenuItem>
                    {generateYearsOptions()}
                </Select>
            </FormControl>
            <FormControl>
                <FormHelperText>Month</FormHelperText>
                <Select value={selectedMonth} onChange={handleMonthChange} displayEmpty>
                    <MenuItem value="" disabled>
                        Month
                    </MenuItem>
                    {generateMonthsOptions()}
                </Select>
            </FormControl>
            <FormControl>
                <FormHelperText>Day</FormHelperText>
                <Select value={selectedDate} onChange={handleDateChange} displayEmpty>
                    <MenuItem value="" disabled>
                        Day
                    </MenuItem>
                    {generateDatesOptions()}
                </Select>
            </FormControl>
</div>

          
                {validateDate() === 'invalid' && (<p style={{padding:"5px 0 0px 0"}} className={"MuiFormHelperText-root Mui-error"}>Invalid date. Please select a valid date.  </p>)}
          
        </div>
    );
};

export default DatePickerDropdown;
